import React from 'react'

export const AIIcon = ({ size = 24, className }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M10.2168 3.75C10.2346 3.75006 10.2441 3.75614 10.2451 3.75684C10.246 3.75813 10.2499 3.76418 10.2539 3.77832L10.7266 5.43066C11.3407 7.58051 13.0106 9.26824 15.1543 9.90332L16.6553 10.3477C16.6703 10.3521 16.6764 10.3562 16.6768 10.3564L16.6826 10.3848C16.6826 10.4023 16.6776 10.4119 16.6768 10.4131L16.6553 10.4219L15.1191 10.877C12.9972 11.5056 11.3376 13.1661 10.709 15.2881L10.2539 16.8232C10.2495 16.8381 10.2456 16.8441 10.2451 16.8447H10.2441C10.2425 16.8458 10.2336 16.8515 10.2168 16.8516C10.1993 16.8516 10.1896 16.8455 10.1885 16.8447L10.1787 16.8232L9.72461 15.2881C9.09597 13.166 7.43555 11.5056 5.31348 10.877L3.77832 10.4219C3.76343 10.4175 3.75744 10.4135 3.75684 10.4131H3.75586C3.755 10.4118 3.75 10.4022 3.75 10.3848C3.75001 10.3673 3.75505 10.3576 3.75586 10.3564H3.75684C3.75764 10.3559 3.76374 10.352 3.77832 10.3477L5.27832 9.90332C7.42209 9.26825 9.0929 7.58053 9.70703 5.43066L10.1787 3.77832C10.1832 3.76262 10.1883 3.75617 10.1885 3.75586C10.1908 3.7545 10.2005 3.75 10.2168 3.75Z"
            stroke="currentColor"
            strokeWidth="1.5"
        />
        <path
            d="M17.3906 15.4111C17.7522 16.3495 18.4863 17.0952 19.417 17.4736C18.4934 17.8434 17.7609 18.5757 17.3906 19.499C17.0202 18.5758 16.289 17.8432 15.3652 17.4736C16.2961 17.0954 17.0289 16.3494 17.3906 15.4111Z"
            stroke="currentColor"
            strokeWidth="1.5"
        />
    </svg>
)
